import keyMirror from 'keymirror';

export default keyMirror({
  FETCH_SHOPPING_CART_START        : null,
  FETCH_SHOPPING_CART_SUCCESS      : null,
  FETCH_SHOPPING_CART_FAILURE      : null,

  UPDATE_SHOPPING_CART_START       : null,
  UPDATE_SHOPPING_CART_SUCCESS     : null,
  UPDATE_SHOPPING_CART_FAILURE     : null,

  CHECKOUT_SHOPPING_CART_START     : null,
  CHECKOUT_SHOPPING_CART_SUCCESS   : null,
  CHECKOUT_SHOPPING_CART_FAILURE   : null
});



// WEBPACK FOOTER //
// banquet/constants/ShoppingCartConstants.js